import {Heading, Img, Button} from "../../../components";
import React from "react";
import { useTranslation } from "react-i18next"

export default function Cover() {

    const { t } = useTranslation();

    const scrollToContactForm = () => {
        const contactSection = document.getElementById("ContactForm");
        if (contactSection) {
            contactSection.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <section id="Cover">
            <div className="container-xs lg:px-6 md:px-5 sm:px-[16px]">
                <div className="flex justify-center rounded-[9999px] md:rounded-[64px] sm:rounded-[32px] bg-[#6C6C6C] lg:pr-20 lg:py-[130px]">
                    <div className=" flex md:grid sm:grid w-full items-center justify-between gap-20 md:gap-5 md:p-10 sm:gap-4 sm:p-4">
                        <Img
                            src="/images/cover.svg"
                            alt="cover"
                            className="object-contain w-[497px] h-[497px] lg:ml-[130px] md:mx-auto sm:w-auto sm:h-auto"
                        />
                        <div className="flex lg:w-[48%] flex-col items-start gap-12 md:gap-9 sm:gap-4">
                            <div className="flex flex-col gap-[24px] self-stretch sm:gap-2">
                                <Heading
                                    size="desktop_heading_1"
                                    className="sm:hidden md:hidden font-medium leading-[110%] text-[#FFFFFF]">
                                    {t("cover.cover_title")}
                                </Heading>
                                <Heading
                                    size="desktop_body_xl"
                                    className="sm:hidden md:hidden font-medium text-[#FFFFFF]">
                                    {t("cover.cover_description")}
                                </Heading>
                                {/*--------------*/}
                                <Heading
                                    size="desktop_heading_2"
                                    className="lg:hidden sm:hidden font-medium leading-[110%] text-[#FFFFFF]">
                                    {t("cover.cover_title")}
                                </Heading>
                                <Heading
                                    size="desktop_body_l"
                                    className="lg:hidden sm:hidden font-medium text-[#FFFFFF]">
                                    {t("cover.cover_description")}
                                </Heading>
                                {/*--------------*/}
                                <Heading
                                    size="desktop_heading_4"
                                    className="lg:hidden md:hidden font-medium leading-[110%] text-[#FFFFFF]">
                                    {t("cover.cover_title")}
                                </Heading>
                                <Heading
                                    size="desktop_body_m"
                                    className="lg:hidden md:hidden font-medium text-[#FFFFFF]">
                                    {t("cover.cover_description")}
                                </Heading>
                            </div>
                            <Button
                                shape="round"
                                onClick={scrollToContactForm}
                                className="h-[56px] sm:h-[44px] w-[320px] bg-[#FFB800] hover:bg-[#FFC224] sm:w-full">
                                <Heading
                                    size="desktop_body_m_bold"
                                    className="font-extrabold text-[#1B1F3B]">
                                    {t("cover.cover_button")}
                                </Heading>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};